app.MenuItemAffinityRunList = app.AbstractCollection.extend({
  model: app.MenuItemAffinityRun,

  comparator(run) {
    return (run.get('generatedAt') || 0) * -1;
  },

  url() {
    return '/api/v2/menu-item-affinity-runs';
  },
});
